export default "__VITE_ASSET__CasWx64D__"